import { IMPORT } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { fromJS } from 'immutable';
import { parseDynamicFilterFamilyId, testDynamicFilterFamily } from 'customer-data-filters-ui/filterQueryFormat/DynamicFilterFamilies';
import { toDSFieldRecord } from 'customer-data-filters-ui/filterQueryFormat/DSFieldRecord/toDSFieldRecord';
import Adapter from './Adapter';
import HttpAdapterConfig from '../adapterConfigs/HttpAdapterConfig';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
export const IMPORT_FETCH_LIMIT = 5000;
export class ImportAdapterConfig extends HttpAdapterConfig {
  constructor(...args) {
    super(...args);
    this.performanceTrackingKey = 'ImportAdapterConfig';
    this.isAssetFamilySupported = assetFamily => {
      return testDynamicFilterFamily(IMPORT, assetFamily);
    };
  }
  getCacheKey(assetFamily) {
    return `IMPORT_${assetFamily}`;
  }
  fetchData(httpClient, assetFamily) {
    const objectTypeId = parseDynamicFilterFamilyId(IMPORT, assetFamily);
    return httpClient(`inbounddb-io/imports/names/${objectTypeId}?limit=${IMPORT_FETCH_LIMIT}`, {
      timeout: 60000
    }).then(response => ({
      data: response[0].options,
      updateImmediate: true
    }));
  }
  formatData(response, assetFamily) {
    const referenceRecords = response.data.map(option => ReferenceRecord({
      id: option.value,
      label: option.label,
      referencedObject: fromJS(option)
    }));
    return toDSFieldRecord(referenceRecords, assetFamily);
  }
}
export default Adapter.makeFromConfig(ImportAdapterConfig);